import $ from 'jquery';
import _ from 'underscore';

export default class Upload {
	constructor() {
		this.selectors = {
			el: '.js-upload',
			input: '.js-upload-input',
			label: '.js-upload-label',
			name: '.js-upload-name',
			size: '.js-upload-size',
			format: '.js-upload-format',
			delete: '.js-upload-delete',
			error: '.upload__error'
		};

		this.states = {
			error: 'upload_state_error',
			success: 'upload_state_success'
		};

		this.text = {
			default: 'Прикрепить файл резюме',
			alternate: 'Прикрепить другой файл',
			errors: {
				size: 'Превышен допустимый размер файла',
				format: 'Недопустимый формат файла',
				require: 'Не выбран файл'
			}
		};

		this.size = {
			limit: 5000000,
			values: ['b', 'kb', 'mb']
		};

		this.extensions = ['pdf', 'doc', 'docx', 'zip', 'rar', 'png', 'jpeg', 'jpg'];

		this.$el = $(this.selectors.el);
	}

	getElements() {
		this.$input = $(this.selectors.input);
		this.$label = $(this.selectors.label);
		this.$delete = $(this.selectors.delete);
		this.$name = $(this.selectors.name);
		this.$size = $(this.selectors.size);
		this.$format = $(this.selectors.format);
		this.$error = $(this.selectors.error);
	}

	getFileFormat = filename => filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);

	onChange = e => {
		const target = e.target;
		const file = target.files[0];

		if (file) {
			const size = file.size;
			const fullName = file.name;
			const name = fullName.slice(0, fullName.lastIndexOf('.'));
			const format = this.getFileFormat(fullName);
			const isFormatValid = _.contains(this.extensions, format);

			if (!isFormatValid) {
				this.setErrorState(this.text.errors.format);
				return;
			}

			if (this.checkSize(size)) {
				this.setErrorState(this.text.errors.size);
				return;
			}

			this.setSuccessState();
			this.setFileInfo(name, size, format);
		} else {
			this.setErrorState(this.text.errors.require);
		}
	};

	setErrorState = error => {
		this.$error.text(error);
		this.$el.addClass(this.states.error);
		this.$label.text(this.text.alternate);
	};

	setSuccessState() {
		this.$el.removeClass(this.states.error);
		this.$el.addClass(this.states.success);
	}

	setFileInfo(name, size, format) {
		this.$name.text(name);
		this.$size.text(this.formatBytes(size));
		this.$format.text(`(${format}`);
	}

	deleteFile = () => {
		this.$input.val('');
		this.$el.removeClass(this.states.success);
		this.$label.text(this.text.default);
	};

	checkSize(size) {
		return (size > this.size.limit);
	}

	formatBytes(size) {
		const k = 1000;
		const dm = 1;
		const i = Math.floor(Math.log(size) / Math.log(k));
		return size > 0 ? `, ${parseFloat((size / Math.pow(k, i)).toFixed(dm))} ${this.size.values[i]}` : '';
	}

	render() {
		if (this.$el.length) {
			this.getElements();
			this.$input.on('change', this.onChange);
			this.$delete.on('click', this.deleteFile);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/upload/index.js
 **/